<template>
    <GastouderMutationOverview
        :idGastouderPeriod="idGastouderPeriod"
        :idChild="idChild"
        :showSubmittedHours="true"
        :hideEmptyDates="true"
        :showHourData="true"
        :showGastouderPeriodStatus="true"
    />
</template>

<script>
import GastouderMutationOverview from "@/views/gastouder/components/GastouderMutationOverview";

export default {
    name: 'GastouderHoursView',
    props:  [
        'idGastouderPeriod',
        'idChild'
    ],
    components: {
        GastouderMutationOverview,
    }
}

</script>